/**
 * 📄 Constantes de los códigos de tipos de documento.
 * Basadas en la columna `code` de la base de datos.
 *
 * ✅ Usar estos valores en lugar de strings hardcoded mejora la legibilidad y evita errores.
 */

export const DOCUMENT_TYPE_CODES = {
  TAX_CREDIT: "03",
  IMPORT: "99",
  EXCLUDED_SUBJECT: "14",
  CREDIT_NOTE: "05",
  DEBIT_NOTE: "06",
  TICKET: "98",
  INVOICE: "01",
  DELIVERY_NOTE: "04",
  WITHHOLDING_RECEIPT: "07",
  LIQUIDATION_RECEIPT: "08",
  ACCOUNTING_LIQUIDATION: "09",
  EXPORT_INVOICE: "11",
  DONATION_RECEIPT: "15",
} as const;

export type DocumentTypeCode = typeof DOCUMENT_TYPE_CODES[keyof typeof DOCUMENT_TYPE_CODES];
